<template>
  <div class="container-fluid">
    <page-header
      :page="page"
      :left-side-class="'col-xl-8'"
      :right-side-class="
        'col-xl-4 align-items-end d-flex pb-2 justify-content-end'
      "
    >
      <template v-slot:customActions>
        <action-button
          i="fas fa-arrow-circle-left"
          variant="outline-success m-1"
          :responsive="false"
          @click="goToOrderBooks"
        >
          Regresar
        </action-button>
      </template>
    </page-header>

    <custom-separator
      v-if="selectedBooks.length > 0"
      text="Libros del estudiante"
      class="my-4 custom-separator-line"
    />

    <CustomChipsGroup
      v-if="selectedBooks.length > 0"
      title=""
      no-background
      object-text="grade"
      object-title="title"
      object-disabled="disabled"
      :selected-items="selectedBooks"
      :on-item-deleted="onRemoveBook"
    />

    <custom-separator
      text="Selección de Libros"
      class="my-4 custom-separator-line"
    />

    <validation-observer ref="formValidatorSearch">
      <filter-manager
        ref="filter"
        v-model="this.filters"
        :display-advanced="false"
        items-container-class="flex-wrap"
        actions-container-class="col-sm-3 ml-0 mr-0 text-right"
        :filters="filtersHeader"
        :search-text="null"
        @search="onSearch"
      >
        <div class="col-12 col-md-auto">
          <action-button
            text="Buscar"
            variant="success"
            class="fr px-4 search mt-1"
            i="fas fa-search"
            :style="{ width: isMobile ? '100%' : '' }"
            @click="onSearch"
          />
        </div>
      </filter-manager>
    </validation-observer>

    <BookRequestSearchResultRow
      v-for="request in requestBooksResult"
      :key="
        `${request.bookId}-${request.academicYearId}-${request.studentSieId}`
      "
      :value="request"
      @onSelectBook="onSelectBook"
    />
    <div class="row">
      <div class="col-12 pt-0">
        <pagination
          v-if="pagination.totalItemCount > pagination.perPage"
          :data="pagination"
          @pagination-go-page="onPageChanged"
        />
      </div>
    </div>

    <CustomResultNotFound
      v-if="showNotResults"
      class="mt-4 row pt-3"
      text="No se ha encontrado resultado de libros para este periodo"
    />
  </div>
</template>

<script>
import PageHeader from "PageHeader";
import CustomSeparator from "custom-separator";
import ActionButton from "ActionButton";
import FilterManager from "FilterManager";
import CustomResultNotFound from "custom-result-not-found";
import mixWait from "@/mixin/loading.mixin";
import mixAlert from "@/mixin/alert.mixin";
import {
  getAcademicYearsForBooksOrder,
  getBooksForOrders,
  assignBookToStudent,
  getStudentBooksOrders,
  removeOrder
} from "@/modules/books-requests/api";
import BookRequestSearchResultRow from "./components/BookRequestSearchResultRow";
import CustomChipsGroup from "CustomChipsGroup";
import store from "@/store/index";
import Pagination from "pagination";
import requestReasonOptions from "@/utils/constants/book/requestReasonOptions";
import { studentBookStatus } from "@/utils/constants/book/studentBookStatus";

const ORDERS_BOOK_ROUTE_NAME = "orderBooks";

export default {
  name: "BookRequestSearch",
  mixins: [mixAlert, mixWait],
  components: {
    PageHeader,
    CustomSeparator,
    CustomChipsGroup,
    ActionButton,
    FilterManager,
    CustomResultNotFound,
    BookRequestSearchResultRow,
    Pagination
  },
  data() {
    return {
      filters: {
        searchText: null,
        academicYear: null
      },
      pagination: {
        perPage: 10,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0
      },
      collections: {
        academicYears: [],
        messages: []
      },
      requestBooksResult: [],
      selectedBooks: []
    };
  },
  methods: {
    async onSearch({ pageIndex = 1, fromSelectedBooks = false } = {}) {
      if (!fromSelectedBooks) {
        const isValid = await this.$refs.formValidatorSearch.validate();
        if (!isValid) {
          this.ShowToast("Alerta", "Información Incompleta.", "error");
          return;
        }
      }

      await getBooksForOrders({
        academicYearId: this.filters.academicYear.id,
        searchField: this.filters.searchText,
        studentSieId: store.getters.SelectedStudent.studentId,
        pageSize: this.pagination.perPage,
        pageIndex: pageIndex > 1 ? this.pagination.currentPage : pageIndex
      }).then(res => {
        this.requestBooksResult = res.data.data;
        this.pagination = {
          ...this.pagination,
          totalItemCount: res.data.totalItemCount,
          pageCount: res.data.pageCount,
          currentPage: res.data.currentPage,
          count: res.data.count
        };
      });
    },
    async onPageChanged(currentPage) {
      this.pagination.currentPage = currentPage;
      await this.onSearch({ pageIndex: currentPage });
    },
    async onSelectBook(value) {
      const order = {
        academicYearId: this.filters.academicYear.id,
        bookId: value.bookId,
        studentSieId: Number(store.getters.SelectedStudent.studentId)
      };
      await assignBookToStudent(order)
        .then(res => {
          if (res.status == 200) {
            this.ShowToast(
              "Proceso exitoso.",
              "El libro ha sido selecionado exitosamente.",
              "success"
            );
            this.selectedBooks.push({
              ...value,
              grade: `Grado: ${value.grade}`
            });
            this.onSearch({ fromSelectedBooks: true });
          }
        })
        .catch(err => {
          if (err && err.response && err.response.data) {
            this.ShowToast("Error", err.response.data.message, "error");
          } else {
            this.ShowToast("Error", err.message, "error");
          }
        });
    },
    async onRemoveBook(value) {
      const confirm = await this.ShowCancelModal(
        "Confirmación",
        `¿Está seguro que desea remover el pedido del libro "${value.title}"?`,
        "Sí",
        "No"
      );

      if (!confirm) {
        return;
      }
      const order = {
        academicYearId: this.filters.academicYear.id,
        bookId: value.bookId,
        studentSieId: Number(store.getters.SelectedStudent.studentId)
      };
      await removeOrder(order)
        .then(res => {
          if (res.status == 200) {
            this.ShowToast(
              "Proceso exitoso.",
              "El libro ha sido removido de mi lista de seleccionados exitosamente.",
              "success"
            );
            const index = this.selectedBooks.findIndex(
              book => book.bookId == value.bookId
            );
            this.selectedBooks.splice(index, 1);
            this.onSearch({ fromSelectedBooks: true });
          }
        })
        .catch(err => {
          if (err && err.response && err.response.data) {
            this.ShowToast("Error", err.response.data.message, "error");
          } else {
            this.ShowToast("Error", err.message, "error");
          }
        });
    },
    async loadAcademicYears() {
      await getAcademicYearsForBooksOrder()
        .then(response => {
          if (response.data.length > 0) {
            this.collections.academicYears = response.data;
          }
        })
        .catch(errm => {
          this.ShowToast(errm.message, "", "error");
        });
    },
    async loadStudentBooksOrders() {
      await getStudentBooksOrders(
        Number(store.getters.SelectedStudent.studentId),
        this.filters.academicYear.id
      ).then(({ data }) => {
        this.selectedBooks = data
          .sort((a, b) => b.statusId - a.statusId)
          .map(book => ({
            ...book,
            disabled: book.statusId !== studentBookStatus.PendientePedido,
            grade: `Grado: ${book.grade}`
          }));
      });
    },
    goToOrderBooks() {
      this.$router.push({
        name: ORDERS_BOOK_ROUTE_NAME,
        query: { academicYear: this.filters.academicYear.description }
      });
    }
  },
  computed: {
    isMobile() {
      return store.getters.getIsMobileDensity;
    },
    showNotResults() {
      return this.requestBooksResult.length == 0;
    },
    page() {
      return {
        icon: "fas fa-book-open",
        title: "Pedido de Libros",
        routes: ["Inicio", "Libros", "Pedido de Libros"]
      };
    },
    filtersHeader() {
      return [
        {
          name: "searchText",
          component: "CustomInput",
          placeholder: "Escriba Grado, Materia o Título",
          icon: "fa fa-search orange-icon",
          leftIcon: true,
          class: "col-12 col-md my-1",
          type: "text",
          error:
            "Favor entrar el grado, materia o titulo para continuar con la búsqueda.",
          validations: "required"
        }
      ];
    },
    requestReasonOptions() {
      return requestReasonOptions;
    }
  },
  async mounted() {
    await this.loadAcademicYears();

    this.filters.academicYear = this.collections.academicYears.find(
      x => x.description == this.$route.query.academicYear
    );

    if (!this.$route.query.academicYear || !this.filters.academicYear)
      this.$router.push({ name: ORDERS_BOOK_ROUTE_NAME });
    await this.loadStudentBooksOrders();
  }
};
</script>

<style scoped>
.success {
  max-height: 38px !important;
}
</style>
